import React, {useEffect, useState} from 'react'
// import {Tab, Tabs, AppBar} from '@material-ui/core'
import "../styles/AdminTransactions.css"
import axios from 'axios'
import Pagination from '@material-ui/lab/Pagination';
import { upperFirst } from 'lodash'
import {ApiURL} from '../constants/ApiUrl'
import axiosInstance from '../services/AxiosInstance';

function AdminTransactions() {

    const [TransactionList, setTransactionList] = useState([])
    const [Page, setPage] = useState(0)
    const [TotalPages, setTotalPages] = useState(0)

    // const AdminSelector = useSelector(state => state.AdminSelector)

    async function getData(page,limit){
        // const result = await axios.get(`${ApiURL}/api/get_transactions?page=${page}&limit=${limit}`);
        const result = await axiosInstance.get(`${ApiURL}/api/get_transactions?page=${page}&limit=${limit}`);
        setTransactionList(result.data.data);
        setTotalPages(result.data.totalPages);
    }

    useEffect(() => {
        getData(0,10);
    }, [])

    useEffect(() => {
        getData(Page,10);
    }, [Page])

    const handlePageChange = (e, value) => {
        // console.log(value);
        setPage(value-1);
    }

    return (
        <>
            <div className="admTrn">
                <h1>Transaction List</h1>
                <Pagination count={TotalPages} page={Page+1} onChange={handlePageChange} variant="outlined" shape="rounded" />
                <table className="trnTable">
                    <tr>
                        <th>Transaction ID</th>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Application ID</th>
                    </tr>
                    {
                        TransactionList.map((item) => (
                            <tr>
                                <td>{item.id}</td>
                                <td>{new Date(item.created_at*1000).toDateString()}</td>
                                <td>{item.amount/100}</td>
                                <td>{upperFirst(item.status)}</td>
                                <td>{item.receipt}</td>
                            </tr>
                        ))
                    }
                </table>
            </div>   
        </>
    )
}

export default AdminTransactions
